module.exports = __webpack_public_path__ + "static/img/nofar-avatar@3x.5ff10c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cx-avatars/nofar-avatar@3x.png
// module id = pwaO
// module chunks = 6